import React,{useState, useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";

import Header from "../components/header/clientHeader";
import ScheduleMeeting from '../components/meetingDetails/scheduleMeeting';
import AddMeetings from '../components/meetingDetails/addMeetings';
import moment from "moment";
import { Buffer } from "buffer";
import mixpanel from 'mixpanel-browser';
import { Oval } from "react-loader-spinner";

// Import supabase configuration
import supabase from "../config/supabase";

import { useNavigate } from "react-router-dom";
import {
  getClientNotification,
} from "../redux/actions/actions";

function AddMeeting() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [justView, setJustView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentAgenda, setCurrentAgenda] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [newProfile, setNewProfile] = useState([]);
  const [clientProfiles, setClientProfiles] = useState([]);
	const [urlWithToken, setUrlWithToken] = useState("");
  const [toHomeUrl,setToHomeUrl] = useState("");

    useEffect( async() => {

      document.title = "Schedule Meeting";
      var url = new URL(window.location.href);
  
      var client_invitation_id = url.searchParams.get("client");
      client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");
  
        await getBoardProfiles(client_invitation_id);
        setShowLoader(false);
    }, []);

    const getBoardProfiles = async (id) => {
      var client = [];
  
      // if (token) {
        var { data, error } = await supabase
          .from("board_clients_invitation")
          .select("*")
          .match({ id: id});
  
        if (data && data.length) {
          client = data;
          let homeUrl = data[0].url_with_token
          homeUrl = homeUrl.split("id")[1]
          setToHomeUrl(homeUrl)
          setUrlWithToken(data[0].url_with_token)
          setClientProfiles(data[0].profiles)
          
          dispatch(getClientNotification(id));
        }
      var sameAgendaProfiles = [];
  
      var profiles =
        client.length && client[0].profiles
          ? await getAllProfiles(client[0].profiles)
          : [];
          profiles.map(async (profile) =>{
            for(let index = 0; index < client[0]?.profiles?.length; index++){
              // For email user/ priavte user
              if(profile.id == client[0].profiles[index].id ){
  
                if(client[0].profiles[index].meetingTime){
                  // Start meeting time
                  profile.dbMeetingTime = client[0].profiles[index].meetingTime;
                  let date  = new Date(client[0].profiles[index].meetingTime);
                  profile.meetingTime = moment(date).format('MMM D, h:mm A') ;
                  profile.meetingDate = moment(date).format('dddd, MMMM Do YYYY') ;
                  var meetingDate = moment(date).format('dddd, MMMM D YYYY');
                  meetingDate = meetingDate.split(' ');
                  meetingDate[2] = meetingDate[2].concat("'");
                  meetingDate = meetingDate.join(' ')
                  profile.meetingDate = meetingDate;
                  profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss') ;
                  
                  // End meeting time
                  profile.dbEndMeetingTime = client[0].profiles[index].endMeetingTime;
                  let endDate  = client[0].profiles[index].endMeetingTime && new Date(client[0].profiles[index].endMeetingTime);
                  profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
                  profile.bgColor = client[0].profiles[index].bgColor
                }
                else{
                  profile.meetingTime = client[0].profiles[index].meetingTime;
                  profile.endMeetingTime = client[0].profiles[index].endMeetingTime;
                  profile.bgColor = client[0].profiles[index].bgColor
                }
              }
  
              // Client hourly rate
              if(profile.id == client[0].profiles[index].id){
                  profile.client_hourly_rate = client[0].profiles[index].rate;
              }
            }
          })
        var tempMeetingTimeArray = [];
        var currentProfileId = localStorage.getItem('clientBoardProfile');
        profiles.forEach((prof)=>{
          if(prof.id === currentProfileId){
            setNewProfile(prof);
          }
          if(prof.meetingTime.length > 0){
            if(tempMeetingTimeArray?.findIndex((el) => el === prof.meetingTime) === -1){
              tempMeetingTimeArray.push(prof.meetingTime)
            }
          }
        })
        var sameAgendaProfiles = [];
        tempMeetingTimeArray.forEach( (el) => {
          var tempArray = [];
          tempArray = profiles.filter( (profile) => profile.meetingTime === el );
          sameAgendaProfiles.push(tempArray);
        })
          sameAgendaProfiles.forEach( (profile) => {
            var afterFilterNewProfile = profile.filter( (p) => p.id !== currentProfileId);
            var date = new Date();
            var d =  moment(date).format('ddd MMM D YYYY HH:mm:ss');
            var res = moment(afterFilterNewProfile[0].fullMeetingTime).isSameOrAfter(d);
            if(res){
              setCurrentAgenda(afterFilterNewProfile);
            }
          })
      setShowLoader(false);
      setLoading(false);
    };
  
    const getAllProfiles = async (ids) => {
      var allIds = [];
      var all_profiles = [];
      ids.forEach( (id) => {
        allIds.push(id.id);
      })
        const { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .in('id', allIds);
  
        if(data && data.length > 0) {
          ids.forEach( (val,index) => {
            data.forEach((profileValue, i) => {
              if(val.id == profileValue.id){
              var profile = { ...data[i], status: ids[index].status, meetingTime: ids[index].meetingTime, endMeetingTime: ids[index].endMeetingTime, cancelUrl: ids[index].cancel_url ? ids[index].cancel_url : '', rescheduleUrl: ids[index].reschedule_url ? ids[index].reschedule_url : '', event_uuid: ids[index].event_uuid ? ids[index].event_uuid : '' ,
              meetingUrl: ids[index].meetingUrl ? ids[index].meetingUrl : '' };
              all_profiles.push(profile);
              }
            })
            // }
          })
          return all_profiles
        } else {
          console.log('no profiles');
        }
    };

    const handleNextButton = async(color) => {
      setShowLoader(true);
      newProfile.meetingTime = currentAgenda[0].meetingTime;
      newProfile.endMeetingTime = currentAgenda[0].endMeetingTime;
      newProfile.reschedule_url = currentAgenda[0].reschedule_url;
      newProfile.cancel_url = currentAgenda[0].cancel_url;
      newProfile.cancel_url = currentAgenda[0].cancel_url;
      newProfile.event_uuid = currentAgenda[0].event_uuid;
      newProfile.meetingUrl = currentAgenda[0].meetingUrl;
      newProfile.bgColor = color;

      var tempProfiles = clientProfiles.map( (el) => {
        if(el.id === newProfile.id) {
          el.meetingTime = currentAgenda[0].dbMeetingTime;
          el.endMeetingTime = currentAgenda[0].dbEndMeetingTime;
          el.reschedule_url = currentAgenda[0].reschedule_url;
          el.cancel_url = currentAgenda[0].cancel_url;
          el.cancel_url = currentAgenda[0].cancel_url;
          el.event_uuid = currentAgenda[0].event_uuid;
          el.meetingUrl = currentAgenda[0].meetingUrl;
          el.bgColor = color;
        }
        return el
      })

      var url = new URL(window.location.href);
  
      var client_invitation_id = url.searchParams.get("client");
      client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");

      var { data, error } = await supabase
          .from("board_clients_invitation")
          .update({profiles: tempProfiles})
          .match({ id: client_invitation_id });

          if(data && data.length){
      
            let date  = new Date(currentAgenda[0].dbMeetingTime);
            var start = moment(date).format('MMMM Do, h:mm A') ;
      
            // End meeting time
            let endDate  = currentAgenda[0].dbEndMeetingTime && new Date(currentAgenda[0].dbEndMeetingTime);
            var end = endDate ? moment(endDate).format('h:mm A') : "";
      
            var name = newProfile.full_name ? newProfile.full_name.split(" ")[0] : "Akira";
            var message = "You have scheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
            await insertNotifications(client_invitation_id,message);
          }
          setShowLoader(false);
      
    }


	const insertNotifications = async(clientId,message) => {
		// localStorage.removeItem("flag");
		var profile_id = localStorage.getItem("clientBoardProfile");

		var { data, error } = await supabase
		.from("notifications")
		.select("*")
		.match({client: clientId, message: message,profileId: newProfile.id})

		if(data && data.length <= 0){
				var { data, error } = await supabase
				.from("notifications")
				.insert({client: clientId, message: message,profileId: newProfile.id})
		
				if(data && data.length){
					localStorage.setItem("showNumber",true);
          await dispatch(getClientNotification(clientId));
					setShowLoader(false);
				}
		}
	}

  async function toCandidates(){
		mixpanel.track('toOtherCandidates');

    if(urlWithToken){
			localStorage.removeItem("loggedIn");
			const url = urlWithToken.split("client")[1];
			navigate(`/client${url}`);
		}
	} 

  const showProfile = (id) => {
    localStorage.setItem("clientBoardProfile", id);
    var url = new URL(window.location.href);
  
    var client_invitation_id = url.searchParams.get("client");

    window.open(
      `${window.location.origin}/clientViewProfile?id=${client_invitation_id}`,
      "_blank"
    );
  }


  return (
    <div className="w-full h-screen">
         <Header justView={!justView} loading={(value) => setLoading(value)} showLogin={localStorage.getItem("supabase.auth.token") ? false : true} toHomeUrl={toHomeUrl} >
            {showLoader && (
          <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
            {/* Add backdrop */}
            
            <div className={`relative flex`}>
              <Oval
                  color="white"
                  secondaryColor="grey"
                  height="40"
                  width="60"
                />
                <div className="flex items-center">Hold Tight-just getting this page ready.</div>
            </div>
          </div>
        )}  
            {/* <ScheduleMeeting /> */}
            {newProfile?.meetingTime ?
            <ScheduleMeeting currentAgenda={currentAgenda} showLoader={showLoader}  newProfile={newProfile} toCandidates={toCandidates} showProfile={(id) => showProfile(id)} />
            :
            <AddMeetings currentAgenda={currentAgenda} newProfile={newProfile} handleNextButton={handleNextButton} showProfile={(id) => showProfile(id)} />}
         </Header>
    </div>
  )
}

export default AddMeeting